import { Card, Group, Text, ThemeIcon, rem } from "@mantine/core"
import { colors } from "../../data"
import { AnimatedWrapper } from "../Common/Renders"
import { IFeature, IQuality } from "./Props"

export function qualityCard(index: number, advantage: IQuality): React.ReactElement {
  return (
    <AnimatedWrapper index={index}>
      <Card shadow="sm" withBorder h={"100%"} style={{ flex: 1, display: "flex", flexDirection: "column" }} key={index}>
        <Group align="center">
          <ThemeIcon variant={"light"} size={rem(48)} radius={rem(24)} color={colors[index % colors.length]}>
            <advantage.icon size={24} />
          </ThemeIcon>
          <Text size={rem(18)} fw={500}>
            {advantage.title}
          </Text>
        </Group>
      </Card>
    </AnimatedWrapper>
  )
}

export function featureCard(index: number, feature: IFeature): React.ReactElement {
  return (
    <AnimatedWrapper index={index}>
      <Card shadow="sm" withBorder h={"100%"} style={{ flex: 1, display: "flex", flexDirection: "column" }} key={index}>
        <Group align="flex-start" p={"sm"}>
          <ThemeIcon variant="light" size={rem(48)} radius={rem(24)} color={colors[index % colors.length]}>
            <feature.icon size={24} />
          </ThemeIcon>
          <div>
            <Text fw={600} size="lg">
              {feature.title}
            </Text>
            <Text c="dimmed" size="md">
              {feature.description}
            </Text>
          </div>
        </Group>
      </Card>
    </AnimatedWrapper>
  )
}
